import { render } from "./ChatEmpty.vue?vue&type=template&id=30e8e391&scoped=true&ts=true"
import script from "./ChatEmpty.vue?vue&type=script&lang=ts"
export * from "./ChatEmpty.vue?vue&type=script&lang=ts"

import "./ChatEmpty.vue?vue&type=style&index=0&id=30e8e391&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30e8e391"]])

export default __exports__